import { MediaThemeElement } from 'media-chrome/dist/media-theme-element';

const template = document.createElement('template');

template.innerHTML = `
<style>
    :host {
        --media-secondary-color: rgb(0 0 0 / 0);
        --media-control-hover-background: rgb(0 0 0 / 0);
        --media-preview-time-display-display: none;
        --media-tooltip-background-color: #222;
    }
    .above-controls media-mute-button:not([mediavolumelevel="off"]) {
        display: none;
    }
    media-play-button {
        --media-button-icon-width: 50px;
        --media-button-icon-height: 50px;
        --media-control-padding: 15px;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        background: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
    }
    media-play-button:not([mediapaused]) {
        opacity: 0;
    }
    media-controller ::slotted([slot='media']) {
      --media-webkit-text-track-transform: scale(0.945) translateY(-172px);
      --media-webkit-text-track-transition: transform 0.15s ease;
    }
    media-controller:not([mediavolumelevel="off"]) ::slotted([slot='media']){
        --media-webkit-text-track-transform: scale(0.945) translateY(-120px);
    }

    .volume-controls {
        display: none;
    }
    @media (min-width: 640px) {
        .volume-controls {
            display: block;
        }
    }
</style>
<template partial="Contents">
  <slot name="media" slot="media"></slot>

    <template if="!nocontrols">
      <div slot="centered-chrome">
          <media-play-button></media-play-button>
      </div>
    </template>

    <media-control-bar style="opacity: 1; display: flex; flex-direction: column; align-items: flex-start;" class="above-controls">
        <media-mute-button style="padding: 0 16px 12px;">
            <div slot="off" style="background: #fff; color: #000; padding: 0 18px; height: 40px; display: flex; align-items: center; border-radius: 20px;">
                <svg style="width: 20px; height: 20px; margin-right: 8px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><rect width="256" height="256" fill="none"/><line x1="48" y1="40" x2="208" y2="216" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><line x1="80" y1="88" x2="80" y2="168" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M192,106.87a32,32,0,0,1,0,42.3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.82-5.3" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><polyline points="112.15 62.99 152 32 152 106.83" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/><path d="M221.67,80a72,72,0,0,1,0,96" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="16"/></svg>
                UNMUTE
            </div>
        </media-mute-button>

        <media-text-display style="opacity: 1; padding: 0 16px 6px; font-weight: bold; font-size: 14px; text-shadow: 0 0 20px rgb(0, 0, 0, 0.9); text-align: left;">
            {{ tagLine }}
        </media-text-display>

        <media-text-display style="opacity: 1; padding: 0 16px 10px; font-weight: bold; font-size: 16px; text-shadow: 0 0 20px rgb(0, 0, 0, 0.9); text-align: left;">
            {{ videoTitle }}
        </media-text-display>
    </media-control-bar>

    <template if="!nocontrols">
      <media-control-bar style="opacity: 1; background: linear-gradient(to top,  rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0) 100%);" if="!hideControls">
          <media-time-range style="padding-left: 16px;"></media-time-range>
          <div class="volume-controls">
              <media-mute-button></media-mute-button>
              <media-volume-range></media-volume-range>
          </div>
          <template if="!hideSubtitles">
              <media-captions-button></media-captions-button>
          </template>
          <media-pip-button></media-pip-button>
          <media-fullscreen-button style="padding-right: 16px;"></media-fullscreen-button>
      </media-control-bar>
    </template>
</template>

<template if="!!defaultSubtitles">
    <media-controller gesturesdisabled defaultsubtitles>
        {{>Contents}}
    </media-controller>
</template>
<template if="!defaultSubtitles">
    <media-controller gesturesdisabled>
        {{>Contents}}
    </media-controller>
</template>
`;

class MediaThemeClearstream extends MediaThemeElement {
  static template = template;
}

if (!window.customElements.get('media-theme-clearstream')) {
  window.customElements.define(
    'media-theme-clearstream',
    MediaThemeClearstream,
  );
}
export default MediaThemeClearstream;
